import { SET_DATA, SET_ITEMS } from '../mutation-types'
import axios from 'axios'

const SET_DASHBOARD = 'SET_DASHBOARD'
const SET_TRANSACTIONS = 'SET_TRANSACTIONS'
const PUSH_TRANSACTION = 'PUSH_TRANSACTION'

export default {
    namespaced: true,

    state: {
        dashboard: { }
    },

    mutations: {
        [SET_DASHBOARD](state, dashboard) {
            state.dashboard = dashboard
        }
    },

    actions: {
        async signIn({ dispatch }, cid) {
            return dispatch('auth/refreshTokens', { cid }, { root: true })
        },

        async fetchDashboard({ commit }) {
            try {
                let response = await axios.get('api/admin/dashboard')
                commit(SET_DASHBOARD, response.data)
            } catch (error) {
                return false
            }

            return true
        }
    },

    modules: {
        companies: {
            namespaced: true,

            state: {
                data: [],
                meta: null
            },

            mutations: {
                [SET_ITEMS](state, { data, meta }) {
                    state.data = data
                    state.meta = meta
                }
            },

            actions: {
                async fetchAll({ commit }, params) {
                    //

                    try {
                        let response = await axios.get('api/admin/companies', { params })
                        commit(SET_ITEMS, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        company: {
            namespaced: true,

            state: {
                data: {},
                transactions: []
            },

            mutations: {
                [SET_DATA](state, data) {
                    state.data = data
                },

                [SET_TRANSACTIONS](state, transactions) {
                    state.transactions = transactions
                },

                [PUSH_TRANSACTION](state, transaction) {
                    state.transactions.unshift(transaction)
                }
            },

            actions: {
                async fetch({ commit }, id) {
                    if (!id) {
                        return null
                    }

                    try {
                        let response = await axios.get(`api/admin/companies/${id}`)
                        commit(SET_DATA, response.data)
                        return response.data
                    } catch (error) {
                        return null
                    }
                },

                async fetchTransactions({ commit }, id) {
                    if (!id) {
                        return null
                    }

                    try {
                        let response = await axios.get(`api/admin/companies/${id}/transactions`)
                        commit(SET_TRANSACTIONS, response.data)
                        return response.data
                    } catch (error) {
                        return null
                    }
                },

                async confirmRequisites({ commit }, { id, isVerified }) {
                    if (!id) {
                        return null
                    }

                    try {
                        let response = await axios.put(`api/admin/companies/${id}`, {
                            'is_verified': isVerified
                        })

                        commit(SET_DATA, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                },

                async createTransaction({ commit, dispatch }, { id, attributes }) {
                    if (!id) {
                        return null
                    }

                    try {
                        const response = await axios.post(`api/admin/companies/${id}/transactions`, attributes)
                        await dispatch('fetch', id)
                        await commit(PUSH_TRANSACTION, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        modems: {
            namespaced: true,

            state: {
                data: [],
                meta: null
            },

            mutations: {
                [SET_ITEMS](state, { data, meta }) {
                    state.data = data
                    state.meta = meta
                }
            },

            actions: {
                async fetchAll({ commit }, params) {
                    try {
                        const response = await axios.get('api/admin/modems', { params })
                        commit(SET_ITEMS, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        transactions: {
            namespaced: true,

            state: {
                data: [],
                meta: null
            },

            mutations: {
                [SET_ITEMS](state, { data, meta }) {
                    state.data = data
                    state.meta = meta
                }
            },

            actions: {
                async fetchAll({ commit }, params) {
                    //

                    try {
                        let response = await axios.get('api/admin/transactions', { params })
                        commit(SET_ITEMS, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        }
    }
}
